export default __webpack_public_path__ + "static/media/img03.5094bdad.jpg";